import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSessionId, logUserAction } from '../utility/commonFunctions';

const sessionId = getSessionId();

const RouteLogger = () => {
  const location = useLocation();

  useEffect(() => {
    logUserAction('ROUTE_CHANGE', {
      path: location.pathname,
      search: location.search,
      sessionId: sessionId,
      userId: localStorage.getItem('userId'),
    });
  }, [location]);

  return null;
};

export default RouteLogger; 